import { Account } from '@syf-api-library/credit-accounts'
import { AnalyticsConfigV2 } from 'marketing-mfe/lib/mfe/MarketingMFE.types'

const accountIdKey = 'cipher.accountId'

export const getAnalyticsV2Config = (
  isAccountServicesPage: boolean,
  accounts: Account[],
  selectedAccount: string | null
): AnalyticsConfigV2 => {
  const defaults: AnalyticsConfigV2 = {
    accountId: null,
    accountIdType: null,
    flow: 'dashboard',
    capability: 'dashboard'
  }
  /*
   * Account Services page with an account selected:
   * Look up the full account details from the accounts list using the
   * selectedAccount cipher.accountId to resolve accountId and accountIdType.
   */
  if (isAccountServicesPage && selectedAccount) {
    const accountInfo = accounts.find(
      (account) => account.info?.[accountIdKey] === selectedAccount
    )
    return {
      accountId: accountInfo?.info?.[accountIdKey] ?? null,
      accountIdType: accountInfo?.info?.accountIdType ?? null,
      flow: 'account_services',
      capability: 'account_services'
    }
  }

  /*
   * Dashboard page with a single account:
   * Analytics account fields (accountId, accountIdType) are only populated
   * when there is a single account.
   */
  if (accounts.length === 1) {
    return {
      ...defaults,
      accountId: accounts[0].info?.[accountIdKey] ?? null,
      accountIdType: accounts[0].info?.accountIdType ?? null
    }
  }

  return defaults
}
